/**
 * Notifications API — real backend (via axios).
 *
 * Unread badges for the customer. One cheap call returns how many UNREAD
 * messages the user has across their NON-CLOSED tickets, split by stream:
 *
 *   GET /user/tickets/unread-summary → { data: { support, clinic, total } }
 *
 * "Unread" = a message from the other party (support agent / clinic) the user
 * hasn't seen; opening a ticket marks it read on the backend. Used by the
 * dashboard "Support" badge and the support-channel chooser.
 */

import axiosInstance from './axiosInstance';

/**
 * @returns {Promise<{ data: { support: number, clinic: number, total: number } }>}
 */
export async function getUnreadSummary() {
  const res = await axiosInstance.get('/user/tickets/unread-summary');
  return res.data;
}

export const notificationsApi = { getUnreadSummary };
export default notificationsApi;
